import { PeopleLeaveRequestStatusDto } from '../people-leave-request-status.dto';
import { PeopleLeaveTypeDto } from '../people-leave-type.dto';
import { PeopleEmployeeDto } from './people-employee.dto';

export class PeopleEmployeeLeaveDto {
  id?: number;
  employeeId?: number;
  leaveTypeId?: number;
  leaveRequestStatusId?: number;
  startDate?: Date;
  endDate?: Date;
  isWholeDay?: boolean;
  startTime?: Date;
  endTime?: Date;
  totalLeaveHours?: number;
  note?: string;
  coveringEmployeeId?: number;
  requestedDate?: Date;
  approvedByUserId?: number;
  approvedDate?: Date;
  createdDate?: Date;
  modifiedDate?: Date;
  lastModifiedUserId?: number;
  version?: number;

  employee?: PeopleEmployeeDto;
  leaveType?: PeopleLeaveTypeDto;
  leaveRequestStatus?: PeopleLeaveRequestStatusDto;
  coveringEmployee?: PeopleEmployeeDto;
}
